import {axios} from "@/utilites/api";
import Config from "@/common/config";

const allClients = () => {
   return axios.get(Config.apiURL + '/users/all')
}

export default {
    allClients
}